export default __webpack_public_path__ + "static/media/d7938744f0e1f052.48dbf3b6e247d252f410601d3f07d49a.svg";